import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "16px",
    height: "42px",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
}));
